module.exports = __webpack_public_path__ + "images/fa15a53f606b515917862b8774bc88e7.svg";